var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"c-btn c-btn--disabled c-btn--w-large c-btn--h-xlarge c-btn--center",on:{"click":_vm.click}},[_vm._v("\n  カタログ応募は終了しました\n")])}
var staticRenderFns = []

export { render, staticRenderFns }